import React from 'react';
import Icon from './Icon';
import UserProfile from './UserProfile';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import { View } from '../App';

interface HeaderProps {
    currentView: View;
    setView: (view: View) => void;
    onOpenWallet: (view?: 'overview' | 'credits') => void;
    isAutoDownload: boolean;
    toggleAutoDownload: () => void;
}

const Header: React.FC<HeaderProps> = ({ currentView, setView, onOpenWallet, isAutoDownload, toggleAutoDownload }) => {
    const { t } = useLanguage();
    const { user } = useAuth();

    return (
        <header className="w-full max-w-[1600px] flex items-center justify-between py-2 md:py-2 z-50">
             <div className="flex items-center gap-2 md:gap-12 shrink-0">
                <div 
                    className="flex items-center gap-2 md:gap-3 group cursor-pointer shrink-0" 
                    onClick={() => setView('designer')}
                >
                      <Icon name="diamond" className="w-6 h-6 md:w-7 md:h-7 text-apple-gold shrink-0" />
                      <h1 className="font-display text-lg md:text-xl font-bold tracking-tight text-slate-900 dark:text-white truncate max-w-[120px] md:max-w-none">
                        {t('appTitle')}
                      </h1>
                </div>
             </div>
             
             <div className="flex items-center gap-2 md:gap-6 shrink-0">
                {/* Note: Language & Theme toggles are now inside UserProfile for a cleaner look */}
                {user && (
                    <UserProfile 
                        setView={setView} 
                        onOpenWallet={onOpenWallet} 
                        isAutoDownload={isAutoDownload}
                        toggleAutoDownload={toggleAutoDownload}
                    />
                )}
            </div>
        </header>
    );
};

export default Header;